<?xml version="1.0" encoding="UTF-8"?>
<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32">
  <defs>
    <style>
      .cls-1 {
        fill: #010202;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <polygon class="cls-1" points="16.1 31 16.1 31 16.1 31 16.1 31"/>
  <path class="cls-1" d="M32.2,11.2c0-2.5-1.2-5-3.2-6.7-3.7-3-9.2-2.5-12.7,1l-.2.2-.2-.2c-3.5-3.5-8.9-4-12.7-.7C1.2,6.5.2,8.7,0,11.4,0,13.9.7,16.6,2.7,18.4l11.2,11.7c.5.7,1.5,1,2.2,1,.7,0,1.7-.2,2.2-1l11.2-11.7c2-2,3-4.5,2.7-7.2Z"/>
</svg>